/**
 * @file settings.api.js
 * @module SettingsAPI
 * @description HTTP API wrapper for application settings endpoints. Methods return Axios promises.
 */

import { axiosInstance } from "./axios";

export const SettingsAPI = {
    /**
     * Get settings for a supplier.
     * @param {string} supplierId - Supplier identifier.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to settings object.
     */
    getSettings: async (supplierId, token = "") => {
        return await axiosInstance(token).get(`/settings/suppliers/${supplierId}`);
    },

    /**
     * Update layout settings for a user.
     * @param {string} userId - User identifier.
     * @param {Object} payload - Partial settings payload.
     * @param {string} [token=""] - Optional authentication token.
     * @returns {Promise} Axios promise resolving to updated settings.
     */
    updateSettingLayoutsByUserId: (userId, payload, token = "") => {
        return axiosInstance(token).patch(`/users/${userId}/settings`, payload);
    }
}